import * as React from 'react'

import { observer } from 'mobx-react'

import { IWorkflowStep, SitePermitStatus } from '~/client/graph'
import ResponsiveSurface from '~/client/src/shared/components/ResponsiveSurface/ResponsiveSurface'
import Localization from '~/client/src/shared/localization/LocalizationManager'

import WorkflowStatusPanel from './WorkflowStatusPanel'

// localization: translated

interface IProps {
  isShown: boolean
  currentStatus: SitePermitStatus
  currentWorkflowStepLevel: number
  workflowSteps: IWorkflowStep[]

  onHide(): void
  setStatusAndStep(status: SitePermitStatus, stepId: string): void

  anchor?: HTMLElement
  isMobileMode?: boolean
}

@observer
export default class WorkflowStatusSelector extends React.Component<IProps> {
  public render() {
    const { isShown, anchor, isMobileMode } = this.props

    return (
      <ResponsiveSurface
        open={isShown}
        onOpenChange={this.onOpenChange}
        title={Localization.translator.updateStatus}
        isMobileMode={isMobileMode}
        anchor={anchor}
        side="top"
        align="end"
      >
        {this.panel}
      </ResponsiveSurface>
    )
  }

  private get panel(): JSX.Element {
    const {
      currentStatus,
      currentWorkflowStepLevel,
      workflowSteps,
      setStatusAndStep,
      onHide,
    } = this.props

    return (
      <WorkflowStatusPanel
        currentStatus={currentStatus}
        currentWorkflowStepLevel={currentWorkflowStepLevel}
        workflowSteps={workflowSteps}
        setStatusAndStep={setStatusAndStep}
        onClose={onHide}
      />
    )
  }

  private onOpenChange = (isOpen: boolean) => {
    if (!isOpen) {
      this.props.onHide()
    }
  }
}
